module.exports = __webpack_public_path__ + "img/hardware3.78ffe311.jpg";